// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Common = require("../utils/Common.bs.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var MM_parser = require("./MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var Belt_HashSetInt = require("rescript/lib/js/belt_HashSetInt.js");
var MM_parenCounter = require("./MM_parenCounter.bs.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_progress_tracker = require("../utils/MM_progress_tracker.bs.js");

function exprEq(a, b) {
  var len1 = a.length;
  var len2 = b.length;
  if (len1 !== len2) {
    return false;
  }
  var eq = true;
  var i = 0;
  while(eq && i < len1) {
    eq = Caml_array.get(a, i) === Caml_array.get(b, i);
    i = i + 1 | 0;
  };
  return eq;
}

function exprCmp(e1, e2) {
  var len1 = e1.length;
  var len2 = e2.length;
  var r = Expln_utils_common.intCmp(len1, len2);
  if (r !== 0) {
    return r;
  }
  var res = 0;
  var i = 0;
  while(i < len1 && res === 0) {
    res = Expln_utils_common.intCmp(Caml_array.get(e1, i), Caml_array.get(e2, i));
    i = i + 1 | 0;
  };
  return res;
}

var ExprCmp = Belt_Id.MakeComparable({
      cmp: exprCmp
    });

var ExprHash = Belt_Id.MakeHashable({
      hash: Expln_utils_common.hashArrInt,
      eq: exprEq
    });

function disjAddPair(disjMap, n, m) {
  if (n === m) {
    return ;
  }
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var set = Belt_HashMapInt.get(disjMap, min);
  if (set !== undefined) {
    return Belt_HashSetInt.add(Caml_option.valFromOption(set), max);
  } else {
    return Belt_HashMapInt.set(disjMap, min, Belt_HashSetInt.fromArray([max]));
  }
}

function forEachCtxInDeclarationOrder(ctx, consumer) {
  var parent = ctx.parent;
  if (parent === undefined) {
    return Curry._1(consumer, ctx);
  }
  var res = forEachCtxInDeclarationOrder(parent, consumer);
  if (res !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(res));
  } else {
    return Curry._1(consumer, ctx);
  }
}

function forEachCtxInReverseOrder(_ctx, consumer) {
  while(true) {
    var ctx = _ctx;
    var res = Curry._1(consumer, ctx);
    if (res !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(res));
    }
    var parent = ctx.parent;
    if (parent === undefined) {
      return ;
    }
    _ctx = parent;
    continue ;
  };
}

function isDebug(ctx) {
  return ctx.contents.debug;
}

function getTokenType(ctx, token) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                var frame = Belt_HashMapString.get(ctx.frames, token);
                if (frame !== undefined) {
                  if (Belt_Option.isNone(frame.proof)) {
                    return /* A */4;
                  } else {
                    return /* P */5;
                  }
                }
                var hyp = Belt_HashMapString.get(ctx.labelToHyp, token);
                if (hyp !== undefined) {
                  if (hyp.typ === /* F */0) {
                    return /* F */2;
                  } else {
                    return /* E */3;
                  }
                }
                var i = Belt_HashMapString.get(ctx.symToInt, token);
                if (i !== undefined) {
                  if (i < 0) {
                    return /* C */0;
                  } else {
                    return /* V */1;
                  }
                }
                
              }));
}

function isConst(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_HashMapString.get(Belt_Option.getExn(ctx.contents.root).symToInt, sym), (function (i) {
                    return i < 0;
                  })), false);
}

function isVar(ctx, sym) {
  return Belt_Option.getWithDefault(Belt_Option.map(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                        return Belt_HashMapString.get(ctx.symToInt, sym);
                      })), (function (i) {
                    return 0 <= i;
                  })), false);
}

function isHyp(ctx, label) {
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    return Belt_HashMapString.get(ctx.labelToHyp, label);
                  })));
}

function isAsrt(ctx, label) {
  return Belt_Option.isSome(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    return Belt_HashMapString.get(ctx.frames, label);
                  })));
}

function disjContains(disj, n, m) {
  var min = n <= m ? n : m;
  var max = n <= m ? m : n;
  var ms = Belt_HashMapInt.get(disj, min);
  if (ms !== undefined) {
    return Belt_HashSetInt.has(Caml_option.valFromOption(ms), max);
  } else {
    return false;
  }
}

function disjForEach(disjMutable, consumer) {
  Belt_HashMapInt.forEach(disjMutable, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  Curry._2(consumer, n, m);
                }));
        }));
}

function disjToArr(disj) {
  var res = [];
  disjForEach(disj, (function (n, m) {
          res.push([
                n,
                m
              ]);
        }));
  var canMerge = function (d1, d2) {
    var canMerge$1 = {
      contents: true
    };
    d1.forEach(function (v1) {
          if (canMerge$1.contents) {
            d2.forEach(function (v2) {
                  if (canMerge$1.contents && v1 !== v2) {
                    canMerge$1.contents = disjContains(disj, v1, v2);
                    return ;
                  }
                  
                });
            return ;
          }
          
        });
    return canMerge$1.contents;
  };
  var merge = function (d1, d2) {
    res.splice(res.findIndex(function (d) {
              return exprEq(d, d2);
            }), 1);
    d2.forEach(function (v2) {
          if (!d1.includes(v2)) {
            d1.push(v2);
            return ;
          }
          
        });
  };
  var findWhatToMerge = function (param) {
    var found;
    for(var i = 0 ,i_finish = res.length - 2 | 0; i <= i_finish; ++i){
      if (Belt_Option.isNone(found)) {
        for(var j = i + 1 | 0 ,j_finish = res.length; j < j_finish; ++j){
          if (Belt_Option.isNone(found)) {
            var d1 = Caml_array.get(res, i);
            var d2 = Caml_array.get(res, j);
            if (canMerge(d1, d2)) {
              found = [
                d1,
                d2
              ];
            }
            
          }
          
        }
      }
      
    }
    return found;
  };
  var mergeFound = true;
  while(mergeFound) {
    var match = findWhatToMerge(undefined);
    if (match !== undefined) {
      merge(match[0], match[1]);
    } else {
      mergeFound = false;
    }
  };
  res.forEach(function (d) {
        d.sort(Expln_utils_common.intCmp);
      });
  return res.sort(exprCmp);
}

function disjForEachArr(disj, consumer) {
  disjToArr(disj).forEach(Curry.__1(consumer));
}

function disjIsEmpty(disjMutable) {
  return Belt_HashMapInt.size(disjMutable) === 0;
}

function isDisj(ctx, n, m) {
  return Belt_Option.getWithDefault(forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                    if (disjContains(ctx.disj, n, m)) {
                      return true;
                    }
                    
                  })), false);
}

function getHypothesis(ctx, label) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.labelToHyp, label);
              }));
}

function exprToHypAdd(ctx, hyp) {
  var expr = hyp.expr;
  var len = expr.length;
  var fstSym = len > 0 ? Caml_array.get(expr, 0) : 0;
  var sndSym = len > 1 ? Caml_array.get(expr, 1) : 0;
  var fstSymToHyp = Belt_HashMapInt.get(ctx.exprToHyp, len);
  if (fstSymToHyp === undefined) {
    return Belt_HashMapInt.set(ctx.exprToHyp, len, Belt_HashMapInt.fromArray([[
                      fstSym,
                      Belt_HashMapInt.fromArray([[
                              sndSym,
                              [hyp]
                            ]])
                    ]]));
  }
  var fstSymToHyp$1 = Caml_option.valFromOption(fstSymToHyp);
  var sndSymToHyp = Belt_HashMapInt.get(fstSymToHyp$1, fstSym);
  if (sndSymToHyp === undefined) {
    return Belt_HashMapInt.set(fstSymToHyp$1, fstSym, Belt_HashMapInt.fromArray([[
                      sndSym,
                      [hyp]
                    ]]));
  }
  var sndSymToHyp$1 = Caml_option.valFromOption(sndSymToHyp);
  var hypsArr = Belt_HashMapInt.get(sndSymToHyp$1, sndSym);
  if (hypsArr === undefined) {
    return Belt_HashMapInt.set(sndSymToHyp$1, sndSym, [hyp]);
  }
  var match = hypsArr.find(function (h) {
        return exprEq(h.expr, hyp.expr);
      });
  if (match !== undefined) {
    return ;
  } else {
    hypsArr.push(hyp);
    return ;
  }
}

function getHypByExpr(ctx, expr) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                var len = expr.length;
                var fstSymToHyp = Belt_HashMapInt.get(ctx.exprToHyp, len);
                if (fstSymToHyp === undefined) {
                  return ;
                }
                var fstSym = len > 0 ? Caml_array.get(expr, 0) : 0;
                var sndSymToHyp = Belt_HashMapInt.get(Caml_option.valFromOption(fstSymToHyp), fstSym);
                if (sndSymToHyp === undefined) {
                  return ;
                }
                var sndSym = len > 1 ? Caml_array.get(expr, 1) : 0;
                var hypsArr = Belt_HashMapInt.get(Caml_option.valFromOption(sndSymToHyp), sndSym);
                if (hypsArr !== undefined) {
                  return Caml_option.undefined_to_opt(hypsArr.find(function (h) {
                                  return exprEq(h.expr, expr);
                                }));
                }
                
              }));
}

function getFrame(ctx, label) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.frames, label);
              }));
}

function getFrameExn(ctx, label) {
  var frame = getFrame(ctx, label);
  if (frame !== undefined) {
    return frame;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Could not find a frame by the label '" + label + "'"
        },
        Error: new Error()
      };
}

function getLocalVars(ctx) {
  return ctx.contents.vars.slice();
}

function getLocalHyps(ctx) {
  return ctx.contents.hyps.slice();
}

function getNumOfVars(ctx) {
  return ctx.contents.varsBaseIdx + ctx.contents.vars.length | 0;
}

function forEachHypothesisInDeclarationOrder(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
                return Expln_utils_common.arrForEach(ctx.hyps, consumer);
              }));
}

function ctxSymToInt(ctx, sym) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapString.get(ctx.symToInt, sym);
              }));
}

function ctxSymToIntExn(ctx, sym) {
  var i = ctxSymToInt(ctx, sym);
  if (i !== undefined) {
    return i;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "The symbol '" + sym + "' is not declared."
        },
        Error: new Error()
      };
}

function ctxSymsToIntsExn(ctx, symbols) {
  return symbols.map(function (param) {
              return ctxSymToIntExn(ctx, param);
            });
}

function ctxStrToIntsExn(ctx, str) {
  return ctxSymsToIntsExn(ctx, Common.getSpaceSeparatedValuesAsArray(str));
}

function ctxIntToSym(ctx, i) {
  if (i < 0) {
    return Belt_Array.get(Belt_Option.getExn(ctx.contents.root).consts, -i | 0);
  } else {
    return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                  if (i < ctx.varsBaseIdx) {
                    return ;
                  } else {
                    return Caml_array.get(ctx.vars, i - ctx.varsBaseIdx | 0);
                  }
                }));
  }
}

function ctxIntToSymExn(ctx, i) {
  var str = ctxIntToSym(ctx, i);
  if (str !== undefined) {
    return str;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot convert " + String(i) + " to a symbol."
        },
        Error: new Error()
      };
}

function ctxIntsToSymsExn(ctx, expr) {
  return expr.map(function (__x) {
              return ctxIntToSymExn(ctx, __x);
            });
}

function ctxIntsToStrExn(ctx, expr) {
  return expr.map(function (__x) {
                return ctxIntToSymExn(ctx, __x);
              }).join(" ");
}

function frmIntToSym(ctx, frame, i) {
  if (i < 0) {
    return ctxIntToSym(ctx, i);
  } else {
    return Belt_Array.get(frame.frameVarToSymb, i);
  }
}

function frmIntToSymExn(ctx, frame, i) {
  var sym = frmIntToSym(ctx, frame, i);
  if (sym !== undefined) {
    return sym;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Could not convert from int " + String(i) + " to a symbol."
        },
        Error: new Error()
      };
}

function frmIntsToSymsExn(ctx, frame, expr) {
  return expr.map(function (__x) {
              return frmIntToSymExn(ctx, frame, __x);
            });
}

function frmIntsToStrExn(ctx, frame, expr) {
  return frmIntsToSymsExn(ctx, frame, expr).join(" ");
}

function getTypeOfVar(ctx, varInt) {
  return forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
                return Belt_HashMapInt.get(ctx.varTypes, varInt);
              }));
}

function getTypeOfVarExn(ctx, varInt) {
  var typ = getTypeOfVar(ctx, varInt);
  if (typ !== undefined) {
    return typ;
  }
  var sym = ctxIntToSym(ctx, varInt);
  var varName = sym !== undefined ? "'" + sym + "'" : String(varInt);
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot determine type of the variable " + varName + ""
        },
        Error: new Error()
      };
}

function extractMandatoryVariables(ctx, asrt, skipEssentialsOpt, param) {
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var res = Belt_HashSetInt.make(16);
  if (!skipEssentials) {
    forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
            if (hyp.typ === /* E */1) {
              hyp.expr.forEach(function (i) {
                    if (i >= 0) {
                      return Belt_HashSetInt.add(res, i);
                    }
                    
                  });
            }
            
          }));
  }
  asrt.forEach(function (i) {
        if (i >= 0) {
          return Belt_HashSetInt.add(res, i);
        }
        
      });
  return res;
}

function extractMandatoryDisj(ctx, mandatoryVars) {
  var mandatoryDisj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  if (Belt_HashSetInt.has(mandatoryVars, n)) {
                    return Belt_HashSetInt.forEach(ms, (function (m) {
                                  if (Belt_HashSetInt.has(mandatoryVars, m)) {
                                    return disjAddPair(mandatoryDisj, n, m);
                                  }
                                  
                                }));
                  }
                  
                }));
        }));
  return mandatoryDisj;
}

function extractMandatoryHypotheses(ctx, mandatoryVars, skipEssentialsOpt, param) {
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var res = [];
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          if (hyp.typ === /* E */1 && !skipEssentials || hyp.typ === /* F */0 && Belt_HashSetInt.has(mandatoryVars, Caml_array.get(hyp.expr, 1))) {
            res.push(hyp);
          }
          
        }));
  return res;
}

function getMandHyps(ctx, expr) {
  var mandatoryVars = extractMandatoryVariables(ctx, expr, undefined, undefined);
  return extractMandatoryHypotheses(ctx, mandatoryVars, undefined, undefined);
}

function getAllHyps(ctx) {
  var hyps = [];
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          hyps.push(hyp);
        }));
  return Belt_MapString.fromArray(hyps.map(function (hyp) {
                  return [
                          hyp.label,
                          hyp
                        ];
                }));
}

function getAllFrames(ctx) {
  var frames = [];
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapString.forEach(ctx.frames, (function (k, v) {
                  frames.push([
                        k,
                        v
                      ]);
                }));
        }));
  return Belt_MapString.fromArray(frames);
}

function getAllFrameLabels(ctx) {
  return Belt_Option.getExn(ctx.contents.root).frameLabels.slice();
}

function forEachFrame(ctx, consumer) {
  return forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
                var result = {
                  contents: undefined
                };
                Belt_HashMapString.forEach(ctx.frames, (function (param, frm) {
                        if (Belt_Option.isNone(result.contents)) {
                          result.contents = Curry._1(consumer, frm);
                          return ;
                        }
                        
                      }));
                return result.contents;
              }));
}

function getNestingLevelPriv(ctx) {
  var pCtx = ctx.parent;
  if (pCtx !== undefined) {
    return 1 + getNestingLevelPriv(pCtx) | 0;
  } else {
    return 0;
  }
}

function getNestingLevel(ctx) {
  return getNestingLevelPriv(ctx.contents);
}

function findParentheses(ctx, onProgress, param) {
  var getAllExprs = function (ctx) {
    var allExpr = [];
    forEachFrame(ctx, (function (frame) {
            frame.hyps.forEach(function (hyp) {
                  if (hyp.typ === /* E */1) {
                    allExpr.push(hyp.expr);
                    return ;
                  }
                  
                });
            allExpr.push(frame.asrt);
          }));
    return allExpr;
  };
  var checkValidParens = function (allExprs, openSym, closeSym) {
    var res = true;
    var openUsed = false;
    var closeUsed = false;
    var parenCnt = MM_parenCounter.parenCntMake([
          openSym,
          closeSym
        ], false, undefined);
    var parenState = /* Balanced */0;
    var allExprsLen = allExprs.length;
    var e = 0;
    while(e < allExprsLen && res) {
      var expr = Caml_array.get(allExprs, e);
      var exprLen = expr.length;
      var s = 0;
      while(s < exprLen && res) {
        var sym = Caml_array.get(expr, s);
        if (!openUsed && sym === openSym) {
          openUsed = true;
        }
        if (!closeUsed && sym === closeSym) {
          closeUsed = true;
        }
        parenState = MM_parenCounter.parenCntPut(parenCnt, sym);
        res = parenState !== /* Failed */2;
        s = s + 1 | 0;
      };
      res = parenState === /* Balanced */0;
      e = e + 1 | 0;
    };
    if (res && openUsed) {
      return closeUsed;
    } else {
      return false;
    }
  };
  var allExprs = getAllExprs(ctx);
  var allConsts = ctxSymsToIntsExn(ctx, Common.getSpaceSeparatedValuesAsArray("( ) [ ] { } [. ]. [_ ]_ <. >. <\" \"> << >> [s ]s (. ). (( ))").filter(function (param) {
              return isConst(ctx, param);
            })).concat(Belt_Array.range(1, Belt_Option.getExn(ctx.contents.root).consts.length - 1 | 0).map(function (i) {
            return -i | 0;
          }));
  var maxC = allConsts.length - 2 | 0;
  var progressState = MM_progress_tracker.progressTrackerMake(0.01, undefined, onProgress, undefined, undefined);
  var foundParens = [];
  for(var c = 0; c <= maxC; ++c){
    var openParen = Caml_array.get(allConsts, c);
    var closeParen = Caml_array.get(allConsts, c + 1 | 0);
    if (!foundParens.includes(openParen) && !foundParens.includes(closeParen) && checkValidParens(allExprs, openParen, closeParen)) {
      foundParens.push(openParen);
      foundParens.push(closeParen);
    }
    MM_progress_tracker.progressTrackerSetCurrPct(progressState, c / maxC);
  }
  return foundParens;
}

function disjMake(param) {
  return Belt_HashMapInt.make(16);
}

function getAllDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  forEachCtxInReverseOrder(ctx.contents, (function (ctx) {
          Belt_HashMapInt.forEach(ctx.disj, (function (n, ms) {
                  Belt_HashSetInt.forEach(ms, (function (m) {
                          disjAddPair(disj, n, m);
                        }));
                }));
        }));
  return disj;
}

function getLocalDisj(ctx) {
  var disj = Belt_HashMapInt.make(16);
  Belt_HashMapInt.forEach(ctx.contents.disj, (function (n, ms) {
          Belt_HashSetInt.forEach(ms, (function (m) {
                  disjAddPair(disj, n, m);
                }));
        }));
  return disj;
}

function createContext(parent, debugOpt, param) {
  var debug = debugOpt !== undefined ? debugOpt : false;
  var pCtxContentsOpt = parent !== undefined ? parent.contents : undefined;
  var ctx = {
    contents: {
      root: undefined,
      parent: pCtxContentsOpt,
      consts: pCtxContentsOpt !== undefined ? [] : [""],
      varsBaseIdx: pCtxContentsOpt !== undefined ? pCtxContentsOpt.varsBaseIdx + pCtxContentsOpt.vars.length | 0 : 0,
      vars: [],
      symToInt: Belt_HashMapString.make(0),
      disj: Belt_HashMapInt.make(16),
      hyps: [],
      labelToHyp: Belt_HashMapString.make(4),
      exprToHyp: Belt_HashMapInt.make(4),
      varTypes: Belt_HashMapInt.make(4),
      lastComment: undefined,
      frames: Belt_HashMapString.make(1),
      frameLabels: [],
      debug: Belt_Option.getWithDefault(Belt_Option.map(pCtxContentsOpt, (function (pCtx) {
                  return pCtx.debug;
                })), debug)
    }
  };
  if (pCtxContentsOpt !== undefined) {
    ctx.contents.root = pCtxContentsOpt.root;
  } else {
    ctx.contents.root = ctx.contents;
  }
  return ctx;
}

function openChildContext(ctx) {
  ctx.contents = createContext(ctx, undefined, undefined).contents;
}

function closeChildContext(ctx) {
  var parent = ctx.contents.parent;
  var tmp;
  if (parent !== undefined) {
    Belt_HashMapString.forEach(ctx.contents.frames, (function (k, v) {
            Belt_HashMapString.set(parent.frames, k, v);
          }));
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot close the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function resetToParentContext(ctx) {
  var parent = ctx.contents.parent;
  var tmp;
  if (parent !== undefined) {
    tmp = parent;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot reset the root context."
          },
          Error: new Error()
        };
  }
  ctx.contents = tmp;
}

function assertNameIsUnique(ctx, name, tokenType) {
  if (name.trim() === "") {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot use an empty string as a name of " + tokenType + "."
          },
          Error: new Error()
        };
  }
  var match = getTokenType(ctx, name);
  if (match === undefined) {
    return ;
  }
  switch (match) {
    case /* C */0 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare the constant '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case /* V */1 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare the variable '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case /* F */2 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare a floating label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case /* E */3 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare an essential label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case /* A */4 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare an axiom label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    case /* P */5 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "An attempt to re-declare a provable label '" + name + "' as " + tokenType + "."
              },
              Error: new Error()
            };
    
  }
}

function ctxIntToFrameInt(ctxToFrameRenum, ctxInt) {
  if (ctxInt < 0) {
    return ctxInt;
  }
  var frameInt = Belt_HashMapInt.get(ctxToFrameRenum, ctxInt);
  if (frameInt !== undefined) {
    return frameInt;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot determine frame variable for the context variable " + String(ctxInt) + "."
        },
        Error: new Error()
      };
}

function renumberVarsInExpr(ctxToFrameRenum, expr) {
  return expr.map(function (param) {
              return ctxIntToFrameInt(ctxToFrameRenum, param);
            });
}

function renumberVarsInDisj(ctxToFrameRenum, disj) {
  return Belt_MapInt.fromArray(Belt_HashMapInt.toArray(disj).map(function (param) {
                  return [
                          ctxIntToFrameInt(ctxToFrameRenum, param[0]),
                          Belt_SetInt.fromArray(renumberVarsInExpr(ctxToFrameRenum, Belt_HashSetInt.toArray(param[1])))
                        ];
                }));
}

function createFrame(ctx, isAxiom, label, exprStr, proof, tokenTypeOpt, skipEssentialsOpt, skipFirstSymCheckOpt, param) {
  var tokenType = tokenTypeOpt !== undefined ? tokenTypeOpt : "a frame";
  var skipEssentials = skipEssentialsOpt !== undefined ? skipEssentialsOpt : false;
  var skipFirstSymCheck = skipFirstSymCheckOpt !== undefined ? skipFirstSymCheckOpt : false;
  assertNameIsUnique(ctx, label, tokenType);
  if (exprStr.length < 1) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Length of an assertion expression must be at least 1."
          },
          Error: new Error()
        };
  }
  if (!skipFirstSymCheck && !isConst(ctx, Caml_array.get(exprStr, 0))) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "The first symbol in an assertion expression must be a constant."
          },
          Error: new Error()
        };
  }
  var sym = exprStr.find(function (sym) {
        return Belt_Option.isNone(ctxSymToInt(ctx, sym));
      });
  if (sym !== undefined) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "The symbol '" + sym + "' must be either a constant or a variable."
          },
          Error: new Error()
        };
  }
  var asrt = exprStr.map(function (param) {
        return ctxSymToIntExn(ctx, param);
      });
  var mandatoryVarsSet = extractMandatoryVariables(ctx, asrt, skipEssentials, undefined);
  var mandatoryVarsArr = Belt_HashSetInt.toArray(mandatoryVarsSet);
  var mandatoryDisj = extractMandatoryDisj(ctx, mandatoryVarsSet);
  var mandatoryHypotheses = extractMandatoryHypotheses(ctx, mandatoryVarsSet, skipEssentials, undefined);
  var ctxToFrameRenum = Belt_HashMapInt.fromArray(mandatoryVarsArr.map(function (cv, fv) {
            return [
                    cv,
                    fv
                  ];
          }));
  return {
          isAxiom: isAxiom,
          disj: renumberVarsInDisj(ctxToFrameRenum, mandatoryDisj),
          hyps: mandatoryHypotheses.map(function (param) {
                return {
                        typ: param.typ,
                        label: param.label,
                        expr: renumberVarsInExpr(ctxToFrameRenum, param.expr)
                      };
              }),
          asrt: renumberVarsInExpr(ctxToFrameRenum, asrt),
          label: label,
          frameVarToSymb: mandatoryVarsArr.map(function (param) {
                return ctxIntToSymExn(ctx, param);
              }),
          varTypes: mandatoryVarsArr.map(function (param) {
                return getTypeOfVarExn(ctx, param);
              }),
          numOfVars: mandatoryVarsArr.length,
          numOfArgs: mandatoryHypotheses.length,
          descr: ctx.contents.lastComment,
          proof: proof,
          dbg: ctx.contents.debug ? ({
                disj: disjToArr(mandatoryDisj).map(function (param) {
                      return ctxIntsToStrExn(ctx, param);
                    }),
                hyps: mandatoryHypotheses.map(function (hyp) {
                      return ctxIntsToStrExn(ctx, hyp.expr);
                    }),
                asrt: ctxIntsToStrExn(ctx, asrt)
              }) : undefined
        };
}

function addAssertion(ctx, isAxiom, label, exprStr, proof) {
  Belt_HashMapString.set(ctx.contents.frames, label, createFrame(ctx, isAxiom, label, exprStr, proof, Belt_Option.isNone(proof) ? "an axiom" : "a theorem", undefined, undefined, undefined));
  Belt_Option.getExn(ctx.contents.root).frameLabels.push(label);
}

function applySingleStmt(ctx, stmt) {
  switch (stmt.TAG | 0) {
    case /* Comment */0 :
        var str = stmt.text;
        ctx.contents.lastComment = str;
        return ;
    case /* Const */1 :
        stmt.symbols.forEach(function (__x) {
              if (Belt_Option.isSome(ctx.contents.parent)) {
                throw {
                      RE_EXN_ID: MM_parser.MmException,
                      _1: {
                        msg: "An attempt to declare a constant '" + __x + "' in an inner block."
                      },
                      Error: new Error()
                    };
              }
              assertNameIsUnique(ctx, __x, "a constant");
              var ctx$1 = ctx.contents;
              Belt_HashMapString.set(ctx$1.symToInt, __x, -ctx$1.consts.length | 0);
              ctx$1.consts.push(__x);
            });
        return ;
    case /* Block */2 :
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Block statements are not accepted by applySingleStmt()."
              },
              Error: new Error()
            };
    case /* Var */3 :
        stmt.symbols.forEach(function (__x) {
              assertNameIsUnique(ctx, __x, "a variable");
              var ctx$1 = ctx.contents;
              Belt_HashMapString.set(ctx$1.symToInt, __x, ctx$1.varsBaseIdx + ctx$1.vars.length | 0);
              ctx$1.vars.push(__x);
            });
        return ;
    case /* Disj */4 :
        var vars = stmt.vars;
        var sym = vars.find(function (sym) {
              return !isVar(ctx, sym);
            });
        if (sym !== undefined) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The symbol '" + sym + "' is not a variable but it is used in a disjoint statement."
                },
                Error: new Error()
              };
        }
        var varInts = vars.map(function (param) {
              return ctxSymToIntExn(ctx, param);
            });
        var maxIdx = varInts.length - 1 | 0;
        for(var i = 0; i <= maxIdx; ++i){
          for(var j = i + 1 | 0; j <= maxIdx; ++j){
            disjAddPair(ctx.contents.disj, Caml_array.get(varInts, i), Caml_array.get(varInts, j));
          }
        }
        return ;
    case /* Floating */5 :
        var label = stmt.label;
        var exprStr = stmt.expr;
        if (exprStr.length !== 2) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Length of a floating expression must be 2."
                },
                Error: new Error()
              };
        }
        assertNameIsUnique(ctx, label, "a floating label");
        var typName = Caml_array.get(exprStr, 0);
        var varName = Caml_array.get(exprStr, 1);
        if (!isConst(ctx, typName)) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The first symbol in the floating '" + typName + "' must be a constant."
                },
                Error: new Error()
              };
        }
        if (!isVar(ctx, varName)) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The second symbol in the floating '" + varName + "' must be a variable."
                },
                Error: new Error()
              };
        }
        var varInt = ctxSymToIntExn(ctx, varName);
        if (Belt_Option.isSome(getTypeOfVar(ctx, varInt))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Cannot redefine typecode for the variable '" + varName + "'"
                },
                Error: new Error()
              };
        }
        var typInt = ctxSymToIntExn(ctx, typName);
        var expr = [
          typInt,
          varInt
        ];
        var hyp = {
          typ: /* F */0,
          label: label,
          expr: expr
        };
        var ctx$1 = ctx.contents;
        ctx$1.hyps.push(hyp);
        Belt_HashMapString.set(ctx$1.labelToHyp, label, hyp);
        exprToHypAdd(ctx$1, hyp);
        return Belt_HashMapInt.set(ctx$1.varTypes, varInt, typInt);
    case /* Essential */6 :
        var label$1 = stmt.label;
        var exprStr$1 = stmt.expr;
        if (exprStr$1.length < 1) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "Length of an essential expression must be at least 1."
                },
                Error: new Error()
              };
        }
        if (!isConst(ctx, Caml_array.get(exprStr$1, 0))) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "The first symbol in an essential expression must be a constant."
                },
                Error: new Error()
              };
        }
        var expr$1 = ctxSymsToIntsExn(ctx, exprStr$1);
        var hyp$1 = {
          typ: /* E */1,
          label: label$1,
          expr: expr$1
        };
        var ctx$2 = ctx.contents;
        ctx$2.hyps.push(hyp$1);
        Belt_HashMapString.set(ctx$2.labelToHyp, label$1, hyp$1);
        return exprToHypAdd(ctx$2, hyp$1);
    case /* Axiom */7 :
        return addAssertion(ctx, true, stmt.label, stmt.expr, undefined);
    case /* Provable */8 :
        return addAssertion(ctx, false, stmt.label, stmt.expr, stmt.proof);
    
  }
}

function loadContext(ast, initialContext, stopBeforeOpt, stopAfterOpt, onPreProcess, expectedNumOfAssertionsOpt, onProgressOpt, debugOpt, param) {
  var stopBefore = stopBeforeOpt !== undefined ? stopBeforeOpt : "";
  var stopAfter = stopAfterOpt !== undefined ? stopAfterOpt : "";
  var expectedNumOfAssertions = expectedNumOfAssertionsOpt !== undefined ? expectedNumOfAssertionsOpt : -1;
  var onProgress = onProgressOpt !== undefined ? onProgressOpt : (function (param) {
        
      });
  var debug = debugOpt !== undefined ? debugOpt : false;
  var assertionsProcessed = {
    contents: 0
  };
  var progressTracker = MM_progress_tracker.progressTrackerMake(0.1, undefined, onProgress, undefined, undefined);
  var onAsrtProcess = function (param) {
    if (expectedNumOfAssertions > 0) {
      assertionsProcessed.contents = assertionsProcessed.contents + 1;
      return MM_progress_tracker.progressTrackerSetCurrPct(progressTracker, assertionsProcessed.contents / expectedNumOfAssertions);
    }
    
  };
  return MM_parser.traverseAst(initialContext !== undefined ? initialContext : createContext(undefined, debug, undefined), ast, (function (ctx, node) {
                  if (onPreProcess !== undefined) {
                    Curry._2(onPreProcess, ctx, node.stmt);
                  }
                  var match = node.stmt;
                  switch (match.TAG | 0) {
                    case /* Block */2 :
                        if (match.level > 0) {
                          openChildContext(ctx);
                        }
                        ctx.contents.lastComment = undefined;
                        return ;
                    case /* Axiom */7 :
                    case /* Provable */8 :
                        break;
                    default:
                      return ;
                  }
                  onAsrtProcess(undefined);
                  if (stopBefore === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }), (function (ctx, node) {
                  var stmt = node.stmt;
                  if (stmt.TAG !== /* Block */2) {
                    applySingleStmt(ctx, stmt);
                  }
                  
                }), (function (ctx, node) {
                  var match = node.stmt;
                  switch (match.TAG | 0) {
                    case /* Block */2 :
                        if (match.level > 0) {
                          closeChildContext(ctx);
                        }
                        return ;
                    case /* Axiom */7 :
                    case /* Provable */8 :
                        break;
                    default:
                      return ;
                  }
                  if (stopAfter === match.label) {
                    return Caml_option.some(undefined);
                  }
                  
                }), undefined)[0];
}

function generateNewVarNames(ctx, types, typeToPrefix, reservedNames, param) {
  var prefixToCnt = Belt_HashMapString.make(Belt_MapString.size(typeToPrefix));
  var getCnt = function (prefix) {
    return Belt_Option.getWithDefault(Belt_HashMapString.get(prefixToCnt, prefix), 0);
  };
  var incCnt = function (prefix) {
    Belt_HashMapString.set(prefixToCnt, prefix, getCnt(prefix) + 1 | 0);
  };
  var maxI = types.length - 1 | 0;
  var res = [];
  for(var i = 0; i <= maxI; ++i){
    var typeStr = ctxIntToSymExn(ctx, Caml_array.get(types, i));
    var prefix = Belt_MapString.getWithDefault(typeToPrefix, typeStr, typeStr);
    incCnt(prefix);
    var newName = {
      contents: prefix + String(getCnt(prefix))
    };
    while(Belt_Option.isSome(getTokenType(ctx, newName.contents)) || Belt_Option.getWithDefault(Belt_Option.map(reservedNames, (function(newName){
              return function (__x) {
                return Belt_HashSetString.has(__x, newName.contents);
              }
              }(newName))), false)) {
      incCnt(prefix);
      newName.contents = prefix + String(getCnt(prefix));
    };
    res.push(newName.contents);
  }
  return res;
}

function generateNewLabels(ctx, prefix, amount, reservedLabels, checkHypsOnlyOpt, param) {
  var checkHypsOnly = checkHypsOnlyOpt !== undefined ? checkHypsOnlyOpt : false;
  var labelIsReserved = function (label) {
    if (Belt_Option.getWithDefault(Belt_Option.map(reservedLabels, (function (__x) {
                  return Belt_HashSetString.has(__x, label);
                })), false) || !checkHypsOnly && Belt_Option.isSome(getTokenType(ctx, label))) {
      return true;
    } else if (checkHypsOnly) {
      return isHyp(ctx, label);
    } else {
      return false;
    }
  };
  var maxI = amount - 1 | 0;
  var cnt = 0;
  var res = [];
  for(var _for = 0; _for <= maxI; ++_for){
    cnt = cnt + 1 | 0;
    var newName = prefix + String(cnt);
    while(labelIsReserved(newName)) {
      cnt = cnt + 1 | 0;
      newName = prefix + String(cnt);
    };
    res.push(newName);
  }
  return res;
}

function renumberConst(constRenum, c) {
  return Belt_Option.getWithDefault(Belt_HashMapInt.get(constRenum, c), c);
}

function renumberConstsInExpr(constRenum, expr) {
  var maxI = expr.length - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var sym = Caml_array.get(expr, i);
    if (sym < 0) {
      Caml_array.set(expr, i, renumberConst(constRenum, sym));
    }
    
  }
}

function moveConstsToBegin(ctx, constsStr) {
  var rootCtx = Belt_Option.getExn(ctx.contents.root);
  var constsToMove = Belt_HashSetInt.fromArray(Common.getSpaceSeparatedValuesAsArray(constsStr).map(function (param) {
                return ctxSymToInt(ctx, param);
              }).filter(function (intOpt) {
              return Belt_Option.mapWithDefault(intOpt, false, (function (i) {
                            return i < 0;
                          }));
            }).map(Belt_Option.getExn));
  var constsLen = Belt_HashSetInt.size(constsToMove);
  var constToMoveFar = {
    contents: -1
  };
  var getConstToMoveFar = function (param) {
    while(Belt_HashSetInt.has(constsToMove, constToMoveFar.contents)) {
      constToMoveFar.contents = constToMoveFar.contents - 1 | 0;
    };
    var res = constToMoveFar.contents;
    constToMoveFar.contents = constToMoveFar.contents - 1 | 0;
    return res;
  };
  var constRenum = Belt_HashMapInt.make(constsLen);
  Belt_HashSetInt.forEach(constsToMove, (function (constToMoveClose) {
          if (constToMoveClose >= (-constsLen | 0)) {
            return ;
          }
          var constToMoveFar = getConstToMoveFar(undefined);
          Belt_HashMapInt.set(constRenum, constToMoveClose, constToMoveFar);
          Belt_HashMapInt.set(constRenum, constToMoveFar, constToMoveClose);
          var symTmp = Caml_array.get(rootCtx.consts, -constToMoveClose | 0);
          Caml_array.set(rootCtx.consts, -constToMoveClose | 0, Caml_array.get(rootCtx.consts, -constToMoveFar | 0));
          Caml_array.set(rootCtx.consts, -constToMoveFar | 0, symTmp);
          Belt_HashMapString.set(rootCtx.symToInt, Caml_array.get(rootCtx.consts, -constToMoveClose | 0), constToMoveClose);
          Belt_HashMapString.set(rootCtx.symToInt, Caml_array.get(rootCtx.consts, -constToMoveFar | 0), constToMoveFar);
        }));
  forEachHypothesisInDeclarationOrder(ctx, (function (hyp) {
          renumberConstsInExpr(constRenum, hyp.expr);
        }));
  forEachFrame(ctx, (function (frame) {
          frame.hyps.forEach(function (hyp) {
                renumberConstsInExpr(constRenum, hyp.expr);
              });
          renumberConstsInExpr(constRenum, frame.asrt);
          renumberConstsInExpr(constRenum, frame.varTypes);
        }));
  forEachCtxInDeclarationOrder(ctx.contents, (function (ctx) {
          var maxI = ctx.vars.length - 1 | 0;
          for(var i = 0; i <= maxI; ++i){
            var $$var = ctx.varsBaseIdx + i | 0;
            var oldTyp = Belt_HashMapInt.get(ctx.varTypes, $$var);
            if (oldTyp !== undefined) {
              Belt_HashMapInt.set(ctx.varTypes, $$var, renumberConst(constRenum, oldTyp));
            }
            
          }
          Belt_HashMapInt.clear(ctx.exprToHyp);
          ctx.hyps.forEach(function (param) {
                return exprToHypAdd(ctx, param);
              });
        }));
}

function ctxOptimizeForProverPriv(ctx) {
  var removeRedundantData = function (ctx) {
    return {
            root: ctx.root,
            parent: ctx.parent,
            consts: ctx.consts,
            varsBaseIdx: ctx.varsBaseIdx,
            vars: ctx.vars,
            symToInt: ctx.symToInt,
            disj: ctx.disj,
            hyps: ctx.hyps,
            labelToHyp: ctx.labelToHyp,
            exprToHyp: ctx.exprToHyp,
            varTypes: ctx.varTypes,
            lastComment: undefined,
            frames: Belt_HashMapString.fromArray(Belt_HashMapString.toArray(ctx.frames).map(function (param) {
                      var frame = param[1];
                      return [
                              param[0],
                              {
                                isAxiom: frame.isAxiom,
                                disj: frame.disj,
                                hyps: frame.hyps,
                                asrt: frame.asrt,
                                label: frame.label,
                                frameVarToSymb: frame.frameVarToSymb,
                                varTypes: frame.varTypes,
                                numOfVars: frame.numOfVars,
                                numOfArgs: frame.numOfArgs,
                                descr: undefined,
                                proof: undefined,
                                dbg: frame.dbg
                              }
                            ];
                    })),
            frameLabels: [],
            debug: ctx.debug
          };
  };
  var parent = ctx.parent;
  if (parent !== undefined) {
    var match = ctxOptimizeForProverPriv(parent);
    var newRoot = match[0];
    var init = removeRedundantData(ctx);
    var res = {
      root: newRoot,
      parent: match[1],
      consts: init.consts,
      varsBaseIdx: init.varsBaseIdx,
      vars: init.vars,
      symToInt: init.symToInt,
      disj: init.disj,
      hyps: init.hyps,
      labelToHyp: init.labelToHyp,
      exprToHyp: init.exprToHyp,
      varTypes: init.varTypes,
      lastComment: init.lastComment,
      frames: init.frames,
      frameLabels: init.frameLabels,
      debug: init.debug
    };
    return [
            newRoot,
            res
          ];
  }
  var res$1 = removeRedundantData(ctx);
  res$1.root = res$1;
  return [
          res$1,
          res$1
        ];
}

function ctxOptimizeForProver(ctx) {
  var match = ctxOptimizeForProverPriv(ctx.contents);
  return {
          contents: match[1]
        };
}

exports.createContext = createContext;
exports.applySingleStmt = applySingleStmt;
exports.openChildContext = openChildContext;
exports.closeChildContext = closeChildContext;
exports.resetToParentContext = resetToParentContext;
exports.loadContext = loadContext;
exports.ctxOptimizeForProver = ctxOptimizeForProver;
exports.isDebug = isDebug;
exports.isConst = isConst;
exports.isVar = isVar;
exports.isHyp = isHyp;
exports.isAsrt = isAsrt;
exports.isDisj = isDisj;
exports.getHypothesis = getHypothesis;
exports.getHypByExpr = getHypByExpr;
exports.getMandHyps = getMandHyps;
exports.getAllHyps = getAllHyps;
exports.getAllFrames = getAllFrames;
exports.getAllFrameLabels = getAllFrameLabels;
exports.getAllDisj = getAllDisj;
exports.getLocalDisj = getLocalDisj;
exports.getFrame = getFrame;
exports.getFrameExn = getFrameExn;
exports.getLocalVars = getLocalVars;
exports.getLocalHyps = getLocalHyps;
exports.getNumOfVars = getNumOfVars;
exports.forEachFrame = forEachFrame;
exports.forEachHypothesisInDeclarationOrder = forEachHypothesisInDeclarationOrder;
exports.getNestingLevel = getNestingLevel;
exports.findParentheses = findParentheses;
exports.getTypeOfVar = getTypeOfVar;
exports.getTypeOfVarExn = getTypeOfVarExn;
exports.getTokenType = getTokenType;
exports.ctxSymToInt = ctxSymToInt;
exports.ctxIntToSym = ctxIntToSym;
exports.ctxSymToIntExn = ctxSymToIntExn;
exports.ctxSymsToIntsExn = ctxSymsToIntsExn;
exports.ctxStrToIntsExn = ctxStrToIntsExn;
exports.ctxIntToSymExn = ctxIntToSymExn;
exports.ctxIntsToSymsExn = ctxIntsToSymsExn;
exports.ctxIntsToStrExn = ctxIntsToStrExn;
exports.frmIntToSym = frmIntToSym;
exports.frmIntToSymExn = frmIntToSymExn;
exports.frmIntsToStrExn = frmIntsToStrExn;
exports.frmIntsToSymsExn = frmIntsToSymsExn;
exports.createFrame = createFrame;
exports.moveConstsToBegin = moveConstsToBegin;
exports.generateNewVarNames = generateNewVarNames;
exports.generateNewLabels = generateNewLabels;
exports.disjMake = disjMake;
exports.disjAddPair = disjAddPair;
exports.disjContains = disjContains;
exports.disjToArr = disjToArr;
exports.disjForEachArr = disjForEachArr;
exports.disjForEach = disjForEach;
exports.disjIsEmpty = disjIsEmpty;
exports.exprEq = exprEq;
exports.ExprCmp = ExprCmp;
exports.ExprHash = ExprHash;
/* ExprCmp Not a pure module */
